import script from "./DetailPage.vue?vue&type=script&setup=true&name=DetailPage&lang=js"
export * from "./DetailPage.vue?vue&type=script&setup=true&name=DetailPage&lang=js"

import "./DetailPage.vue?vue&type=style&index=0&id=f33b0cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f33b0cb8"]])

export default __exports__